import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-darkGray text-white" data-id="element-33">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-34">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-35">
          <div data-id="element-36">
            <h3 className="text-2xl font-serif font-bold mb-4" data-id="element-37">MerchantPro</h3>
            <p className="text-gray-300 text-sm" data-id="element-38">
              Procesamiento de pagos + POS | Atención en español
            </p>
          </div>

          <div data-id="element-39">
            <h4 className="font-semibold mb-4" data-id="element-40">Enlaces Rápidos</h4>
            <div className="space-y-2" data-id="element-41">
              <Link to="/" className="block text-gray-300 hover:text-gold transition-colors text-sm" data-id="element-42">
                Inicio
              </Link>
              <Link to="/#servicios" className="block text-gray-300 hover:text-gold transition-colors text-sm" data-id="element-43">
                Servicios
              </Link>
              <Link to="/contacto" className="block text-gray-300 hover:text-gold transition-colors text-sm" data-id="element-44">
                Contacto
              </Link>
            </div>
          </div>

          <div data-id="element-45">
            <h4 className="font-semibold mb-4" data-id="element-46">Contacto</h4>
            <div className="space-y-2 text-sm text-gray-300" data-id="element-47">
              <div className="flex items-center space-x-2" data-id="element-48">
                <Phone size={16} data-id="element-49" />
                <span data-id="element-50">(954) 931-4833</span>
              </div>
              <div className="flex items-center space-x-2" data-id="element-51">
                <Mail size={16} data-id="element-52" />
                <span data-id="element-53">guillermo@vitalmerchantsolutions.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400" data-id="element-54">
          <p data-id="element-55">
            &copy; {new Date().getFullYear()} MerchantPro. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}